import { render, staticRenderFns } from "./LiftFloorBlacklist.vue?vue&type=template&id=3f6c8ffa&scoped=true&"
import script from "./LiftFloorBlacklist.vue?vue&type=script&lang=js&"
export * from "./LiftFloorBlacklist.vue?vue&type=script&lang=js&"
import style0 from "./LiftFloorBlacklist.vue?vue&type=style&index=0&id=3f6c8ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6c8ffa",
  null
  
)

export default component.exports